import debounce from "lodash.debounce";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  FormDashboardLabel as Label,
  FormDashboardInput as Input,
  FormRow,
} from "../../../components";
import { inputNormalizer } from "../../../utils";
import { useInternationalization } from "../../i18n";
import { SystemProvider } from "../../system/provider";
import { updateForm } from "../slice";

const FormLocationOnline = () => {
  const dispatch = useDispatch()
  const form = useSelector(state => state.eventForm.data)
  const { channelOptions } = useSelector(state => state.system)
  const { translate } = useInternationalization()

  const handleUpdateForm = debounce((e) => {
    dispatch(updateForm({key: 'location_online_need_update', value: true}))
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  return (
    <React.Fragment>
      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('GENERAL', 'location')} ({translate('GENERAL', 'online')})
      </p>

      <FormRow>
        <Label>{translate('GENERAL', 'channel')}</Label>
        <SystemProvider>
          <Select
            className="text-sm"
            value={form.location_online_channel}
            options={channelOptions}
            onChange={(e) => inputNormalizer(e, 'location_online_channel', handleUpdateForm)}
          />
        </SystemProvider>
      </FormRow>

      <FormRow>
        <Label>URL</Label>
        <Input
          placeholder="https://"
          className="w-full"
          defaultValue={form.location_online_url}
          name="location_online_url"
          onChange={(e) => {e.persist(); handleUpdateForm(e)}}
        />
      </FormRow>

      <FormRow>
        <Label>{translate('AUTH', 'email')}</Label>
        <Input
          type="email"
          className="w-full"
          defaultValue={form.location_online_email}
          name="location_online_email"
          onChange={(e) => {e.persist(); handleUpdateForm(e)}}
        />
      </FormRow>

      <FormRow>
        <Label>{translate('GENERAL', 'phone')}</Label>
        <Input
          className="w-full"
          defaultValue={form.location_online_phone}
          name="location_online_phone"
          onChange={(e) => {e.persist(); handleUpdateForm(e)}}
        />
      </FormRow>
    </React.Fragment>
  )
}

export { FormLocationOnline }
